<template>
  <div class="qrcode">
    <div class="qrcode-container" ref="qrcode-container"></div>
    <template v-if="qrcodeSrc">
      <el-image
        style="width: 150px; height: 150px"
        :src="qrcodeSrc"
        :preview-src-list="[qrcodeSrc]"
      />
      <a :href="qrcodeSrc" class="btn-download" :download="downloadFileName" v-if="downloadFileName">
        <el-button type="primary">{{ $t('download') }}</el-button>
      </a>
    </template>
  </div>
</template>

<script>
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import QRCode from 'qrcodejs2';
  import { sleep } from 'beans-admin-plugin';

  @Component
  export default class Qrcode extends Vue {
    @Prop(String) text;
    @Prop(String) downloadFileName;
    @Prop({ type: Number, default: 1200 }) size;

    qrcodeSrc = '';

    mounted() {
      this.createQrcode();
    }

    async createQrcode() {
      const container = this.$refs['qrcode-container'];
      container.innerHTML = '';
      new QRCode(container, {
        text: this.text,
        width: this.size,
        height: this.size
      });
      await sleep(200);
      this.qrcodeSrc = container.querySelector('img').src;
    }

    @Watch('text')
    async onChange() {
      await this.$nextTick();
      this.createQrcode();
    }
  }
</script>

<style lang="scss" scoped>
.qrcode-container {
  position: fixed;
  left: -200%;
  width: 0;
  height: 0;
  overflow: hidden;
  display: none;
}

.qrcode {
  width: 150px;
  text-align: center;
}

.btn-download {
  margin-top: 10px;
}
</style>
